import { LOCATION_CHANGE } from 'connected-react-router';

import {
  ADD_USERS_START,
  ADD_USERS_SUCCESS,
  ADD_USERS_ERROR,
  SHOW_USER_START,
  SHOW_USER_SUCCESS,
  SHOW_USER_ERROR,
  CREATE_USER_START,
  CREATE_USER_SUCCESS,
  CREATE_USER_ERROR,
  UPDATE_USER_START,
  UPDATE_USER_SUCCESS,
  UPDATE_USER_ERROR,
} from '../constants/User';

const defaultState = {
  path: null,

  item: {},
  itemLoading: false,
  itemFetched: false,

  items: [],
  itemsFetched: false,
  itemsLoading: false,
  meta: { page: 1, pageSize: 10 },

  errorMessage: null,
};

export default function UserReducer(
  state = defaultState,
  { type, payload, items, meta, errorMessage, item }
) {
  switch (type) {
    case LOCATION_CHANGE:
      return state.path === payload.pathname
        ? { ...state }
        : { ...defaultState, path: payload.pathname };

    case ADD_USERS_START:
      return {
        ...state,
        itemsLoading: true,
        itemsFetched: false,
      };

    case ADD_USERS_SUCCESS:
      return {
        ...state,
        itemsLoading: false,
        errorMessage: null,
        itemsFetched: true,
        items,
        meta,
      };

    case ADD_USERS_ERROR:
      return {
        ...state,
        itemsLoading: false,
        itemsFetched: false,
        errorMessage,
      };

    case SHOW_USER_START:
      return {
        ...state,
        itemLoading: true,
        itemFetched: false,
      };

    case SHOW_USER_SUCCESS:
      return {
        ...state,
        itemLoading: false,
        itemFetched: true,
        errorMessage: null,
        item,
      };

    case SHOW_USER_ERROR:
      return {
        ...state,
        itemLoading: false,
        itemFetched: false,
        errorMessage,
      };

    case CREATE_USER_START:
      return {
        ...state,
        itemLoading: true,
      };

    case CREATE_USER_SUCCESS:
      return {
        ...state,
        itemLoading: false,
        errorMessage: null,
        item,
      };

    case CREATE_USER_ERROR:
      return {
        ...state,
        itemLoading: false,
        errorMessage,
      };

    case UPDATE_USER_START:
      return {
        ...state,
        itemLoading: true,
      };

    case UPDATE_USER_SUCCESS:
      return {
        ...state,
        itemLoading: false,
        errorMessage: null,
        item,
      };

    case UPDATE_USER_ERROR:
      return {
        ...state,
        itemLoading: false,
        errorMessage,
      };

    default:
      return state;
  }
}
